import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Loans from "@/pages/admin/Loans";
import LoanDetail from "@/pages/admin/LoanDetail";
import Collections from "@/pages/admin/Collections";
import MyLoans from "@/pages/borrower/MyLoans";
import NotFound from "@/pages/NotFound";
import LoanAgreement from "@/pages/borrower/LoanAgreement";
import Compliance from "@/pages/admin/Compliance";
import SplashScreen from "@/components/SplashScreen";
import PWAInstallPrompt from "@/components/PWAInstallPrompt";
import { Toaster } from "sonner";

import Login from "@/pages/Login";
import Register from "@/pages/Register";

import BorrowerDashboard from "@/pages/borrower/Dashboard";
import ApplicationFlow from "@/pages/borrower/ApplicationFlow";
import ApplicationDetail from "@/pages/borrower/ApplicationDetail";
import Notifications from "@/pages/borrower/Notifications";

import ReviewerDashboard from "@/pages/reviewer/ReviewerDashboard";
import ApplicationReview from "@/pages/reviewer/ApplicationReview";

import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminApplications from "@/pages/admin/Applications";
import LoanProducts from "@/pages/admin/LoanProducts";
import UsersAdmin from "@/pages/admin/Users";
import AuditLogs from "@/pages/admin/AuditLogs";
import Templates from "@/pages/admin/Templates";

function RoleHome() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Login/>;
  return <Navigate to={`/${user.role}`} replace />;
}

function App() {
  return (
    <div className="App">
      <SplashScreen />
      <PWAInstallPrompt />
      <AuthProvider>
        <BrowserRouter>
          <Toaster richColors position="top-right"/>
          <Routes>
            <Route path="/" element={<RoleHome/>}/>
            <Route path="/login" element={<Login/>}/>
            <Route path="/register" element={<Register/>}/>

            <Route path="/borrower" element={<ProtectedRoute roles={["borrower"]}><BorrowerDashboard/></ProtectedRoute>}/>
            <Route path="/borrower/apply" element={<ProtectedRoute roles={["borrower"]}><ApplicationFlow/></ProtectedRoute>}/>
            <Route path="/borrower/applications/:id/edit" element={<ProtectedRoute roles={["borrower"]}><ApplicationFlow/></ProtectedRoute>}/>
            <Route path="/borrower/applications/:id" element={<ProtectedRoute roles={["borrower"]}><ApplicationDetail/></ProtectedRoute>}/>
            <Route path="/borrower/loans" element={<ProtectedRoute roles={["borrower"]}><MyLoans/></ProtectedRoute>}/>
            <Route path="/borrower/applications/:id/agreement" element={<ProtectedRoute roles={["borrower"]}><LoanAgreement/></ProtectedRoute>}/>
            <Route path="/borrower/notifications" element={<ProtectedRoute roles={["borrower"]}><Notifications/></ProtectedRoute>}/>

            <Route path="/reviewer" element={<ProtectedRoute roles={["reviewer", "admin"]}><ReviewerDashboard/></ProtectedRoute>}/>
            <Route path="/reviewer/applications/:id" element={<ProtectedRoute roles={["reviewer", "admin"]}><ApplicationReview/></ProtectedRoute>}/>

            <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminDashboard/></ProtectedRoute>}/>
            <Route path="/admin/applications" element={<ProtectedRoute roles={["admin"]}><AdminApplications/></ProtectedRoute>}/>
            <Route path="/admin/products" element={<ProtectedRoute roles={["admin"]}><LoanProducts/></ProtectedRoute>}/>
            <Route path="/admin/users" element={<ProtectedRoute roles={["admin"]}><UsersAdmin/></ProtectedRoute>}/>
            <Route path="/admin/audit" element={<ProtectedRoute roles={["admin"]}><AuditLogs/></ProtectedRoute>}/>
            <Route path="/admin/loans" element={<ProtectedRoute roles={["admin", "reviewer"]}><Loans/></ProtectedRoute>}/>
            <Route path="/admin/loans/:id" element={<ProtectedRoute roles={["admin", "reviewer"]}><LoanDetail/></ProtectedRoute>}/>
            <Route path="/admin/collections" element={<ProtectedRoute roles={["admin", "reviewer"]}><Collections/></ProtectedRoute>}/>
            <Route path="/admin/compliance" element={<ProtectedRoute roles={["admin", "reviewer"]}><Compliance/></ProtectedRoute>}/>
            <Route path="/admin/templates" element={<ProtectedRoute roles={["admin"]}><Templates/></ProtectedRoute>}/>
            <Route path="*" element={<NotFound/>}/>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
